import { Column } from '@cdab/scania/qpr/components'
import { TdsButton } from '@scania/tegel-react'
import styled from 'styled-components'

export const ColumnOtherDocuments = styled(Column)`
  margin-top: var(--tds-spacing-layout-16);

  @media (min-width: ${({ theme }) => theme.size.lg}) {
    margin-top: 0;
  }
`

export const Headline = styled.h4.attrs({
  className: 'tds-headline-04'
})`
  margin-bottom: 16px;
  @media (min-width: ${({ theme }) => theme.size.md}) {
    margin-top: 0;
  }
`

export const HeadlineRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`
export const SpinnerWrapper = styled.div`
  padding-left: 32px;
`
export const ButtonsWrapper = styled.div`
  display: flex;
`

export const StyledButton = styled(TdsButton)`
  padding-left: 8px;
`

export const TabsContent = styled.div`
  padding: 24px 24px 48px;
  background-color: var(--tds-white);
`
